import copy from "copy-to-clipboard";
import React, { useCallback, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import OverlayTrigger from "react-bootstrap/esm/OverlayTrigger";
import Popover from "react-bootstrap/esm/Popover";
import FacebookIcon from "react-share/lib/FacebookIcon";
import LinkedinIcon from "react-share/lib/LinkedinIcon";
import TwitterIcon from "react-share/lib/TwitterIcon";
import { Icon } from "../../components";
import { useI18n } from "../../lib/i18n/i18n_provider";

import "./social_media_share.css";
import { useAnalytics } from "../../lib/analytics/analytics";

export function SocialMediaShare() {
  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}${window.location.pathname}`;
  const { fbt } = useI18n();
  const analytics = useAnalytics();

  const handleCopy = useCallback(() => {
    copy(url);
    setCopied(true);
    setTimeout(() => {
      setShow(false);
      setCopied(false);
    }, 500);
  }, [url]);

  const handleShareOnFacebook = useCallback(() => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
    );
  }, [url]);

  const handleShareOnTwitter = useCallback(() => {
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`
    );
  }, [url]);

  const handleShareOnLinkedIn = useCallback(() => {
    window.open(
      `https://linkedin.com/shareArticle?url=${encodeURIComponent(url)}`
    );
  }, [url]);

  const handleToggle = (value?: boolean) => {
    const isShow = value === undefined ? !show : value;
    setShow(isShow);

    if (isShow) {
      analytics.event(
        "Share Click",
        {
          Source: "WL",
        },
        { onlyProviders: ["mixpanel", "customerio"] }
      );
    }
  };

  const popover = (
    <Popover id="popover-share">
      <Popover.Body>
        {copied ? (
          <Button
            variant="link"
            className="d-block text-decoration-none text-primary"
            disabled
          >
            {fbt("copied")}
          </Button>
        ) : (
          <Button
            variant="link"
            className="d-block text-decoration-none"
            onClick={handleCopy}
          >
            <Icon name="copy" className="icon text-primary" />
            <span className="social_media_share__name">{fbt("copy")}</span>
          </Button>
        )}
        <Button
          variant="link"
          className="d-block text-decoration-none"
          onClick={handleShareOnTwitter}
        >
          <TwitterIcon className="icon" />
          <span className="social_media_share__name">Twitter</span>
        </Button>
        <Button
          variant="link"
          className="d-block text-decoration-none"
          onClick={handleShareOnLinkedIn}
        >
          <LinkedinIcon className="icon" />
          <span className="social_media_share__name">LinkedIn</span>
        </Button>
        <Button
          variant="link"
          className="d-block text-decoration-none"
          onClick={handleShareOnFacebook}
        >
          <FacebookIcon className="icon" />
          <span className="social_media_share__name">Facebook</span>
        </Button>
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom-start"
      overlay={popover}
      show={show}
      onToggle={handleToggle}
      rootClose
    >
      <Button
        variant="outline-primary"
        className="d-flex align-items-center social_media_share"
      >
        {fbt("share")}
        <span className="social_media_share__title">
          <Icon
            name={"share"}
            className="icon icon-share"
            color={"currentColor"}
          />
        </span>
      </Button>
    </OverlayTrigger>
  );
}
